import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import './BrDisplayGrid.scss';

export default function BrDisplayGrid(props) {
  const { gridItemCount, onGridItemClick, lastSelectableGridItemNumber, currSelectionValue } = props;

  const endItemRef = useRef();

  useEffect(() => {
    if (endItemRef.current) { endItemRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }, [currSelectionValue]);

  const getGridClassName = (index) => {
    if (index < currSelectionValue - 1) { return 'seq-locked'; }
    if (index === currSelectionValue - 1) { return 'sel-range-end-item'; }
    if (index < lastSelectableGridItemNumber) { return 'seq-lock-allowed'; }
    return 'seq-lock-not-allowed';
  };

  const handleGridItemClick = (index) => {
    if (index + 1 <= lastSelectableGridItemNumber) { onGridItemClick(index); }
  };

  // Can be a separate component
  const getGridItem = (index) => {
    return (
      <div
        key={index}
        className={`grid-cell ${getGridClassName(index)}`}
        onClick={() => handleGridItemClick(index)}
        ref={index === currSelectionValue - 1 ? endItemRef : null}
      >
        p
        {index + 1}
      </div>
    );
  };

  return (
    <div className="br-display-grid-container">
      {Array(gridItemCount)
        .fill(null)
        .map((cell, index) => getGridItem(index))}
    </div>
  );
}

BrDisplayGrid.propTypes = {
  gridItemCount: PropTypes.number,
  onGridItemClick: PropTypes.func,
  lastSelectableGridItemNumber: PropTypes.number,
  currSelectionValue: PropTypes.number,
};
